import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export function formatBigNumber(num) {
  if (isNaN(num)) {
    return '';
  }
  var sign = num < 0 ? '-' : '';
  var _Math$abs$toString$sp = Math.abs(num).toString().split('e'),
    _Math$abs$toString$sp2 = _slicedToArray(_Math$abs$toString$sp, 2),
    mantissa = _Math$abs$toString$sp2[0],
    exponent = _Math$abs$toString$sp2[1];
  if (!exponent) {
    return sign + mantissa;
  }
  var exponentValue = parseInt(exponent, 10);
  var _mantissa$split = mantissa.split('.'),
    _mantissa$split2 = _slicedToArray(_mantissa$split, 2),
    integerPart = _mantissa$split2[0],
    _mantissa$split2$ = _mantissa$split2[1],
    decimalPart = _mantissa$split2$ === void 0 ? '' : _mantissa$split2$;
  if (exponentValue < 0) {
    return sign + '0.' + '0'.repeat(Math.abs(exponentValue) - 1) + integerPart + decimalPart;
  } else {
    return sign + integerPart + decimalPart + '0'.repeat(Math.max(0, exponentValue - decimalPart.length));
  }
}